module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/financial-unit-lvl2-75.965cac9c.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/financial-unit-lvl2-75.png
// module id = 3530
// module chunks = 11